import React, { FC, useState } from 'react'
import { IParamPick } from '../../../types'
import DownIcon from '../../../../public/static/icons/down.svg'
import cx from 'classnames'
import css from './ParamPicker.module.scss'
import Image from '../../../common/Image/Image'
import PickerImage from './PickerImage'
import ParamPickerModal from '../../../modals/ParamPickerModal'
import PercentSvg from '../../../../public/static/icons/icon-percent.svg'

const pickerOptions = {
  color: {
    title: 'выберите цвет',
    notPicked: 'цвет не выбран',
    openList: 'Открыть список цветов',
    closeList: 'Закрыть список цветов',
  },
  aroma: {
    title: 'выберите аромат',
    notPicked: 'аромат не выбран',
    openList: 'Открыть список ароматов',
    closeList: 'Закрыть список ароматов',
  },
}

interface ItemPickerProps {
  picked: IParamPick
  onPick: (IParamPick) => void
  params: IParamPick[]
  type: 'aroma' | 'color'
}

const ParamPicker: FC<ItemPickerProps> = ({ picked, onPick, params, type }) => {
  const items = params.map((param) => ({
    ...param,
    name: param.item,
  }))
  const [open, setOpen] = useState(false)
  const [hoveredName, setHoveredName] = useState<string>(null)

  return (
    <div>
      <p className={css.title}>
        {pickerOptions[type].title}:{' '}
        {picked && <span>{hoveredName ? hoveredName : picked?.item}</span>}
      </p>
      <ul className={css.picker} onPointerLeave={() => setHoveredName(null)}>
        {items.map((item) => (
          <li
            key={item.id}
            className={cx(
              css.image_wrapper,
              picked?.id === item.id && css.active,
            )}
            onClick={() => {
              onPick(item)
            }}
            onPointerEnter={() => setHoveredName(item.name)}
          >
            <div className={css.imgWrapper}>
              {item.priceOld !== item.price && (
                <span className={css.icon}>
                  <PercentSvg />
                </span>
              )}
              <figure className={css.image}>
                <Image
                  src={item.image}
                  objectFit="cover"
                  width={56}
                  height={56}
                  title={item.name}
                  loading="eager"
                />
              </figure>
            </div>
          </li>
        ))}
      </ul>
      <div className={css.picker_mobile} onClick={() => setOpen(true)}>
        <div className={css.picked}>
          {picked ? (
            <PickerImage item={picked} />
          ) : (
            <span>{pickerOptions[type].notPicked}</span>
          )}

          <button
            type="button"
            title={pickerOptions[type].openList}
            className={css.down}
          >
            <DownIcon />
          </button>
        </div>
      </div>
      <ParamPickerModal
        picked={picked}
        onPick={onPick}
        items={items}
        open={open}
        setOpen={setOpen}
        title={pickerOptions[type].title}
        closeButtonText={pickerOptions[type].closeList}
      />
    </div>
  )
}

export default ParamPicker
